import { useState } from 'react';
import { faqs } from '../data';
import SectionHeader from './SectionHeader';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <SectionHeader
        kicker="FAQ"
        title="常见问题"
        desc="关于导航吃瓜的分类逻辑、更新节奏与使用方式，这里一次说清楚。"
      />
      <div className="mx-auto max-w-3xl space-y-3">
        {faqs.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={f.q}
              className={`overflow-hidden rounded-2xl border transition ${
                isOpen ? 'border-primary-200 bg-primary-50/60' : 'border-background-200/80 bg-background-100/50'
              }`}
            >
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex w-full items-center gap-4 px-5 py-4 text-left"
                aria-expanded={isOpen}
              >
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm ${isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                  {isOpen ? <i className="ri-subtract-line" aria-hidden="true"></i> : <i className="ri-add-line" aria-hidden="true"></i>}
                </span>
                <h3 className="text-[15px] font-semibold text-foreground-900">{f.q}</h3>
              </button>
              {isOpen ? (
                <div className="px-5 pb-5 pl-16">
                  <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
}